import { defineStore } from 'pinia';
import {
  ref
} from '@nuxtjs/composition-api';

export const useProductStore = defineStore('productStore', () => {
  const productList = ref([])
  const loading = ref(false)
  const currentCategoryID = ref('')


  return {
    productList,
    loading,
    currentCategoryID
  }
})
